<template>
  <div class="sidebar"
       :data-color="activeColor"
       :data-image="backgroundImage"
       :data-background-color="backgroundColor"
       :style="sidebarStyle">

    <div class="logo">
      <!-- Esto esconde el logo chico de la izquierda -->
      <!--<a href="" class="simple-text logo-mini" target="_blank">
        <div class="logo-img">
          <img :src="logo">
        </div>
      </a>-->


      <!--<router-link to="/"><h3>Ag<strong>BI</strong></h3></router-link>-->
      <span class="simple-text logo-normal">
        <template><h3>Ag<strong>BI</strong></h3></template>
      </span>
      <!-- Esto esconde la accion de hacer la barra izquierda desplegable -->
      <!--<div class="navbar-minimize">
        <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
        <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
      </md-button>
      </div>-->
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'eMediaMarket'
    },
    activeColor: {
      type: String,
      default: 'blue',
      validator: (value) => {
        let acceptedValues = ['', 'primary', 'azure', 'green', 'orange', 'danger', 'rose', 'blue']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundImage: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#1F2933',
      validator: (value) => {
        let acceptedValues = ['', 'black','white', 'red', '#1F2933']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    logo: {
      type: String,
      default: 'img/logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide () {
    return {
      autoClose: this.autoClose
    }
  },
  /**
       * ESTO HACE QUE DE ENTRADA EL SIDEBAR ESTE ABIERTO
       */
  mounted: function() {
    this.$sidebar.toggleMinimize();
  },
  methods: {


    minimizeSidebar () {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    }
  },
  computed: {
    sidebarStyle () {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  },
  beforeDestroy () {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
}

</script>
<style>
  .sidebar .logo, .off-canvas-sidebar .logo{
    margin: 0 15px !important;
  }
  .sidebar-logo{
    max-width: 190px;
  }
  .sidebar .logo:after, .off-canvas-sidebar .logo:after{
    width:100% !important;
    right: 0 !important;
  }
  .sidebar .logo{
    padding-bottom: 0 !important;
  }

  .logo-normal h3{
    margin: 0;
  }
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }


</style>
